import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  disable365IntegrationError,
  disable365IntegrationSuccess,
  disablePowershellIntegrationError,
  disablePowershellIntegrationSuccess,
  getStatus365Error,
  getStatus365Success,
  getStatusPowershellError,
  getStatusPowershellSuccess,
} from './actions'
import {
  DISABLE_365_INTEGRATION_REQUEST_ASYNC,
  DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC,
  STATUS_365_REQUEST_ASYNC,
  STATUS_POWERSHELL_REQUEST_ASYNC,
} from './constants'

const get365StatusEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      STATUS_365_REQUEST_ASYNC.INITIATE,
      DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    }),
    mergeMap(() =>
      api.settings.getO365Status(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getStatus365Success(response)),
        catchError((error) => of(epicsErrorHandler(getStatus365Error, error)))
      )
    )
  )

const getPowershellStatusEpic = (action$, state$, { api, epicsErrorHandler }) =>
  // only if 365 success?
  action$.pipe(
    ofType(
      STATUS_POWERSHELL_REQUEST_ASYNC.INITIATE,
      DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    }),
    mergeMap(() =>
      api.settings.getPowershellStatus(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getStatusPowershellSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getStatusPowershellError, error)))
      )
    )
  )

const disable365IntegrationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISABLE_365_INTEGRATION_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.disableO365Integration(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => disable365IntegrationSuccess(response)),
        catchError((error) => of(epicsErrorHandler(disable365IntegrationError, error)))
      )
    )
  )

const disablePowershellIntegrationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .disablePowershellIntegration(state$.value.partnerOptions.selectedCompany?.value)
        .pipe(
          map((response) => disablePowershellIntegrationSuccess(response)),
          catchError((error) => of(epicsErrorHandler(disablePowershellIntegrationError, error)))
        )
    )
  )

export default combineEpics(
  get365StatusEpic,
  disable365IntegrationEpic,
  getPowershellStatusEpic,
  disablePowershellIntegrationEpic
)
